module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic16.3664787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic16.png
// module id = 515
// module chunks = 1